// extracted by mini-css-extract-plugin
export var center = "_55-2";
export var clickableRow = "_55-5";
export var expandedRow = "_55-7";
export var hoverable = "_55-4";
export var left = "_55-1";
export var right = "_55-3";
export var row = "_55-0";
export var selectedRow = "_55-6";
export var summaryRow = "_55-8";